import clsx from "clsx";
import type { KeyboardEvent } from "react";
import ClipboardComponent from "@/app/components/ui/Clipboard";
import Input from "@/app/components/ui/Inputs/Input";
import { IMobileNumberWithScriptCopyProps } from "@/app/components/ui/interface";

const DEFAULT_ERROR_MESSAGES = [
  { message: "WhatsApp Number Required", type: "required" as const },
  { message: "Enter a valid 10 digit mobile number", type: "pattern" as const },
  { message: "Enter a valid 10 digit mobile number", type: "minLength" as const },
];

const ALLOWED_CONTROL_KEYS = new Set([
  "Backspace",
  "Delete",
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowDown",
  "Home",
  "End",
  "Tab",
  "Enter",
]);

const restrictToDigits = (event: KeyboardEvent<HTMLInputElement>) => {
  if (ALLOWED_CONTROL_KEYS.has(event.key)) return;
  if (event.ctrlKey || event.metaKey) return;
  if (!/^[0-9]$/.test(event.key)) {
    event.preventDefault();
  }
};

const MobileNumberWithScriptCopy: React.FC<IMobileNumberWithScriptCopyProps> = ({
  register,
  fieldError,
  errorMessages = DEFAULT_ERROR_MESSAGES,
  mobileValue,
  script,
  placeholder = "Mobile Number",
  maxLength = 10,
  className,
  inputClassName = "w-[182px] rounded-[6px] text-[12px]",
  tooltipText = "Copy Script",
  copyLabel = "Copy Script",
  showCopyLabel = true,
  disabled,
  onCopyText,
}) => {
  return (
    <div className={clsx("flex flex-col gap-2", className)}>
      <span className="flex items-center gap-1 font-medium text-[#0068FF] self-end cursor-pointer">
        <ClipboardComponent
          className="right-0"
          copyId={mobileValue ?? ""}
          text={script}
          tooltipText={tooltipText}
          onCopyText={onCopyText}
        />
        {showCopyLabel && (
          <ClipboardComponent
            copyId={mobileValue ?? ""}
            text={script}
            tooltipText={tooltipText}
            onCopyText={onCopyText}
            render={<span className="text-xs">{copyLabel}</span>}
          />
        )}
      </span>
      <div className="bg-[#e7f8ef] rounded-md p-4 text-xs mb-1 text-[#1F1F23] whitespace-pre-line max-h-[40vh] overflow-y-auto">
        {script}
      </div>
      <Input
        register={register}
        type="tel"
        inputMode="numeric"
        maxLength={maxLength}
        fieldError={fieldError}
        errorMessages={errorMessages}
        placeholder={placeholder}
        disabled={disabled}
        onKeyDown={restrictToDigits}
        className={inputClassName}
      />
    </div>
  );
};

export default MobileNumberWithScriptCopy;
